import { Common, Accessors } from "../../../helper";

const pupilCloumns = [
    
  {
    Header: "",
    accessor: Accessors.Action,
  },
  {
    Header: Common.SurName,
    accessor: Accessors.LastName,
  },
  {
    Header: Common.ForeName,
    accessor: Accessors.FirstName,
  },
  {
    Header: Common.Characteristics,
    accessor: Accessors.OtherNeeds,
  },
  {
    Header: Common.Upn,
    accessor: Accessors.Upn,
  },
  {
    Header: Common.Class,
    accessor: Accessors.Classname,
  },
  {
    Header: Common.SchoolYear,
    accessor: Accessors.Year,
  },
  {
    Header: Common.Gender,
    accessor: Accessors.Gender,
  },
  {
    Header: Common.Dob,
    accessor: Accessors.Dob,
  },
  {
    Header: Common.Ethnicity,
    accessor: Accessors.Ethnicity,
  },
  {
    Header: Common.GLD,
    accessor: Accessors.Eyfs,
  },
  {
    Header: Common.SenStatus,
    accessor: Accessors.SenStatus,
  },
  {
    Header: Common.Ks1Result,
    accessor: Accessors.KsResults,
  },
];

export { pupilCloumns };
